export enum AgentCodes {
  STATUS_OK = 200,

  CACHE_SAVE_FAILURE = 800, // The object in a successful peer content response failed to save to the cache

  INVALID_PAYLOAD = 801, // Invalid payload received in peer content response

  INVALID_CACHE_ENTRY = 802, // Cache returned an invalid entry after peer response

  FETCH_REQUEST_TIMEOUT = 803, // Fetch request timed out, kernel failed to respond

  CONTENT_ENCODING_FAILURE = 804, // Failed to encode content

  CONNECTION_CLOSED = 810, // Webrtc connection closed (clean)

  CONNECTION_SEND_FAILURE = 811, // Failed to send on the webrtc data channel

  CONNECTION_TIMED_OUT = 812, // Webrtc connection timed out

  PAYLOAD_TOO_LARGE = 813, // Attempted to send a payload that was too large over a webrtc connection

  CONNECTION_KEEP_ALIVE_TIMEOUT = 814,

  DATACHANNEL_CLOSED = 820,

  DATACHANNEL_UNKNOWN_ERROR = 821,

  DATACHANNEL_UNINITIALIZED = 822,

  DATACHANNEL_NEGOTIATION_ON_CLOSED_CHANNEL = 823,

  DATACHANNEL_NOT_READY = 824,

  DATACHANNEL_BUFFER_FULL = 825,

  DATACHANNEL_TIMED_OUT = 826,

  DATACHANNEL_FAILED_STATE_TRANSITION = 827,

  DATACHANNEL_FAILED_LOCAL_DESCRIPTION = 828,

  SIGNAL_SERVICE_UNAVAILABLE = 840,

  AGENT_SHUTDOWN = 841
}
